import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { starRatingStarTypes } from 'angular-star-rating/lib/interfaces/star-rating-config.interface';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-rate-operator',
  templateUrl: './rate-operator.component.html',
  styleUrls: ['./rate-operator.component.scss'],
})
export class RateOperatorComponent implements OnInit {
  @Input() operatorId: number;

  public review = {
    comment: '',
    rating: 0,
    operatorId: 0,
  };
  public starType: starRatingStarTypes = 'svg';

  constructor(
    private modalController: ModalController,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private navCtrl: NavController
  ) {}

  ngOnInit() {
    this.review.operatorId = this.operatorId;
  }

  close() {
    this.modalController.dismiss();
  }

  async sendReview() {
    try {
      const res = await this.httpSv.itemAction(
        this.review,
        'operatorReviews',
        'create'
      );

      if (res.status) {
        await this.uiSv.presentAlert('Se ha enviado tu reseña', false);
        await this.navCtrl.navigateRoot('/home', { replaceUrl: true });
        this.close();
      }
    } catch (error) {
      console.error(error);
    }
  }
}
